// extracted by mini-css-extract-plugin
module.exports = {"SPDealDetail":"DealMainSpLinks_SPDealDetail__HNSSE","SPDealDetailLink":"DealMainSpLinks_SPDealDetailLink__eEm3y","UnreadCountBadge":"DealMainSpLinks_UnreadCountBadge__eurAB"};